module.exports = __webpack_public_path__ + "media/slider/WelcomeToComposz-9179e6ed.jpg";